// extracted by mini-css-extract-plugin
module.exports = {"miscellaneous":"Miscellaneous_miscellaneous__uoh1g","title":"Miscellaneous_title__YHnW8"};